var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "transparent",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ddd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M9.994 4.28C8.328 2.332 5.55 1.808 3.462 3.592c-2.087 1.783-2.381 4.765-.742 6.875 1.363 1.754 5.488 5.453 6.84 6.65.151.134.227.201.315.228a.42.42 0 0 0 .239 0c.088-.027.163-.094.315-.228 1.351-1.197 5.476-4.896 6.84-6.65 1.639-2.11 1.38-5.11-.743-6.875-2.123-1.765-4.865-1.26-6.532.688Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconGrey);
export default __webpack_public_path__ + "static/media/heart-icon-grey.67aed71e321b7b6852df3bfc21e4e6f6.svg";
export { ForwardRef as ReactComponent };